class AudioService {
  private audioContext: AudioContext | null = null

  private initAudioContext(): void {
    if (!this.audioContext) {
      this.audioContext = new (window.AudioContext ||
        (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)()
    }
  }

  private beep(
    frequency: number,
    duration: number,
    type: OscillatorType = 'triangle',
    gain = 0.02
  ): void {
    this.initAudioContext()
    if (!this.audioContext) return

    const oscillator = this.audioContext.createOscillator()
    const gainNode = this.audioContext.createGain()

    oscillator.type = type
    oscillator.frequency.value = frequency
    gainNode.gain.value = gain

    oscillator.connect(gainNode)
    gainNode.connect(this.audioContext.destination)

    oscillator.start()
    oscillator.stop(this.audioContext.currentTime + duration)
  }

  playTick(intensity: number): void {
    // Much quieter and simpler progressive crack sounds
    const frequencies = [380, 400, 430, 460] // More subtle pitch progression
    const durations = [0.04, 0.045, 0.05, 0.055] // Shorter durations
    const gains = [0.005, 0.007, 0.009, 0.012] // Much quieter volumes
    
    const freq = frequencies[Math.min(intensity - 1, 3)] || 400
    const duration = durations[Math.min(intensity - 1, 3)] || 0.045
    const gain = gains[Math.min(intensity - 1, 3)] || 0.007
    
    // Keep it simple - just triangle wave
    this.beep(freq, duration, 'triangle', gain)
    
    // Remove the second harmonic to simplify the sound
  }

  playCrack(): void {
    // Much simpler and quieter final crack sound
    this.beep(200, 0.06, 'triangle', 0.015) // Single, quieter crack sound
    // Remove the multiple overlapping sounds to make it less overwhelming
  }

  playMiss(): void {
    // Low, disappointing sound for misses
    this.beep(150, 0.08, 'sawtooth', 0.008)
  }
}

export const audioService = new AudioService()
